// extracted by mini-css-extract-plugin
export default {"myPage":"index_myPage__b9LcY"};